import {ModuleRouteManifest} from '../types'

export const graduateCardRouteManifest: ModuleRouteManifest = {
  code: 'graduate-card',
  privateRoutes: ['graduate-card', 'graduate-applications/*'],
}
